import axios from 'axios';
import index from './index';
export default {
  getData() {
    return axios.get(`/modules/${index.api}/`);
  },
  getImage(filename, checksum) {
    return axios({ method: 'get', url: `/medias/messaging/${filename}/${checksum}`, responseType: 'blob' });
  },

  sendMessagingAction(messagingActions) {
    return axios.post(`/modules/messaging/sendbox`, messagingActions);
  },
  acknowledgeMessageReceiption(message) {
    //return axios.post(`/modules/messaging/actions/acknowledge-message-receiption`,message)
  },
  getConnectedUsers() {
    try {
      return axios.post('/modules/messaging/connected-users');
    } catch (err) {
      console.warn('Failed to getConnectedUsers');
    }
  },
};
